var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer-simple section"},[_c('FooterBottom'),_c('button',{staticClass:"page-top",on:{"click":_vm.pageTop}},[_c('img',{attrs:{"src":require("@/assets/images/page-top.png"),"alt":""}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }